import i18n from "../../../../../constants/i18n";
import { TalkhattabatConversationType } from "../../../../../Types";
import Et3Image from "../../../../../core/et3-Image";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../core/et3-text";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import getKhattabatBulkMessagingStore from "../../../../../stores/khattabat-stores/messaging-stores/bulk-messaging-store";

const SendButton = withLiteObserverAndTheme<{
  conversationType: TalkhattabatConversationType;
}>((props) => {
  const { theme, conversationType } = props;
  const { colors, unitX } = theme;
  const { shouldSendMessages, isSendingMessages, sendAllMessages } =
    getKhattabatBulkMessagingStore();

  return (
    <ET3Div
      width={1510}
      height={40}
      alignItems={"center"}
      fDirection={"column"}
      style={{}}
      color={""}
      justifyContent={"center"}
      withShadow={false}
      isExtendable={true}
      isScrollable={false}
      onClick={() => {}}
    >
      <ET3Div
        width={108}
        height={40}
        alignItems={"center"}
        fDirection={"row"}
        justifyContent={"center"}
        style={{
          backgroundColor: shouldSendMessages.get()
            ? colors.all.bondiBlue
            : colors.all.gray,
          borderRadius: 41 * unitX,
          cursor: "pointer"
        }}
        color={""}
        withShadow={false}
        isExtendable={false}
        isScrollable={false}
        onClick={() =>
          shouldSendMessages.get() ? sendAllMessages(conversationType) : null
        }
      >
        <Et3Text
          fontFamily={"LIGHT"}
          fontSize={18}
          isSpan={false}
          text={
            isSendingMessages.get() ? i18n.get("SENDING") : i18n.get("SEND")
          }
          style={{}}
          color={colors.all.white}
        />
        {isSendingMessages.get() ? null : (
          <>
            <Et3Margin left={1} right={1} top={0} bottom={0} />
            <Et3Image
              type="LOCAL"
              alt={i18n.get("USER")}
              imageName={"send"}
              size={18}
              onClick={() => {}}
              style={{}}
            />
          </>
        )}
      </ET3Div>
    </ET3Div>
  );
});

export default SendButton;
